import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../../assets/svgs/projects.svg";

import { getAllPageSections } from "store/actions";

import Table from "./Table";
import ControlArea from "components/Layout/ControlArea";

const Locations = () => {
  const dispatch = useDispatch();
  const { sections, loading, error } = useSelector((state) => state.section);
  const { formatMessage, locale } = useIntl();

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  useEffect(() => {
    dispatch(getAllPageSections("locations"));
  }, [dispatch]);

  return (
    <div className="property-wrap">
      <ControlArea
        btnTxt={<FormattedMessage id={"add-location"} />}
        cardTxt={<FormattedMessage id={"locations"} />}
        icon={Icon}
        url="/locations/add"
      />
      <Table data={sections} loading={loading} />
    </div>
  );
};

export default Locations;
